import type { CaptionFormFieldFragment } from "../../client/generated";
import { useTranslation } from "react-i18next";
import { useRef } from "react";
import { RegionSelectContent } from "../../regions/RegionSelectContent";
import {
  FormControl,
  FormField,
  FormLabel,
} from "@acdc2/ui/components/access-form";
import {
  Select,
  SelectTrigger,
  SelectValue,
} from "@acdc2/ui/components/select";

type Props = {
  fragment: CaptionFormFieldFragment;
  value: string;
  onValueChange: (value: string) => void;
};

export function CaptionFormField({ fragment, value, onValueChange }: Props) {
  const { t } = useTranslation();
  const currentPageGroupRef = useRef<HTMLDivElement>(null);

  const selectedPage = fragment.document.pages.pages.find((page) =>
    page.regions.some((region) => region.id === value),
  );

  const handleOpenChange = (isOpen: boolean) => {
    if (isOpen && !selectedPage) {
      setTimeout(() => {
        currentPageGroupRef.current?.scrollIntoView({
          block: "start",
          behavior: "smooth",
        });
      });
    }
  };

  return (
    <FormField name="caption">
      <FormLabel>{t("CaptionFormField.label")}</FormLabel>
      <Select
        value={value}
        onValueChange={onValueChange}
        onOpenChange={handleOpenChange}
      >
        <FormControl asChild>
          <SelectTrigger className="w-full">
            <SelectValue placeholder={t("CaptionFormField.placeholder")}>
              {t("CaptionFormField.selection", { page: selectedPage?.index })}
            </SelectValue>
          </SelectTrigger>
        </FormControl>
        <RegionSelectContent
          fragment={fragment}
          currentPageGroupRef={currentPageGroupRef}
          qualifyingAttributes={[
            "ImageAttribute",
            "FigureAttribute",
            "TableAttribute",
          ]}
        />
      </Select>
    </FormField>
  );
}
